import React from 'react';

export function PhotoPlaceholder({
  label = 'Foto',
  hint = 'Reemplazar',
  height = 200,
  radius,
  className = '',
}) {
  const style = { height };
  if (radius != null) style.borderRadius = radius;

  return (
    <div className={`ds-photo-placeholder ${className}`.trim()} style={style}>
      <div className="ds-photo-placeholder__stripe" aria-hidden />
      <span className="ds-photo-placeholder__corner ds-photo-placeholder__corner--tl" aria-hidden />
      <span className="ds-photo-placeholder__corner ds-photo-placeholder__corner--tr" aria-hidden />
      <span className="ds-photo-placeholder__corner ds-photo-placeholder__corner--bl" aria-hidden />
      <span className="ds-photo-placeholder__corner ds-photo-placeholder__corner--br" aria-hidden />
      <div className="ds-photo-placeholder__label">
        <span className="ds-photo-placeholder__tick" aria-hidden />
        <span>{label}</span>
        {hint ? <span className="ds-photo-placeholder__hint">{hint}</span> : null}
      </div>
    </div>
  );
}

export default PhotoPlaceholder;
